module.exports = __webpack_public_path__ + "static/media/logo-epa-mini-S.15c90563.svg";